import { takeEvery } from 'redux-saga/effects';
import { logoutSaga, requestPasswordResetSaga, resendAccountVerificationCodeSaga, signInUserSaga, verifyAccountSaga } from './auth';
import { addImportantPlaceSaga, fetchImportantPlacesSaga, updateImportantPlaceSaga } from './fav';
import { fetchGroupPostsListSaga } from './groups';
import { fetchHelpContentSaga } from './help';
import {
  createLogSaga,
  fetchDraftsSaga,
  fetchLogSaga,
  fetchLogsDetailsSaga,
  fetchMembersForLogsSaga,
  fetchMultiViewColumnSaga,
  fetchTagsForLogsSaga,
  logAddRemoveMembersSaga,
  logInviteNewUsersSaga,
  logLeaveSaga,
  logRemoveArchivedUsersSaga,
  logTransferHostSaga,
  logUpdateSaga,
  logUpdateUserAccessSaga,
} from './logs';
import {
  addCommentImageToPostSaga,
  addPostSaga,
  deletePostSaga,
  duplicatePostSaga,
  editPostSaga,
  entryCommentUpdateSaga,
  fetchPostSaga,
  initPostFormSaga,
  submitPostCommentSaga,
  uploadPostImageSaga,
} from './post';
import { fetchRecentPlacesSaga, fetchUserRecentActivitySaga } from './recent';
import { deleteManagedAccountSaga, updateEmailSaga, updatePasswordSaga, uploadProfileImageSaga, userSearchSaga } from './user';
import * as actionTypes from 'store/actions/actionTypes';

export function* watchAuth() {
  yield takeEvery(actionTypes.VERIFY_ACCOUNT, verifyAccountSaga);
  yield takeEvery(actionTypes.RESEND_ACCOUNT_VERIFICATION_CODE, resendAccountVerificationCodeSaga);
  yield takeEvery(actionTypes.SIGN_IN, signInUserSaga);
  yield takeEvery(actionTypes.LOGOUT, logoutSaga);
  yield takeEvery(actionTypes.REQUEST_PASSWORD_RESET, requestPasswordResetSaga);
}

export function* watchUser() {
  yield takeEvery(actionTypes.UPLOAD_PROFILE_IMAGE, uploadProfileImageSaga);
  yield takeEvery(actionTypes.UPDATE_EMAIL, updateEmailSaga);
  yield takeEvery(actionTypes.UPDATE_PASSWORD, updatePasswordSaga);
  yield takeEvery(actionTypes.DELETE_MANAGED_ACCOUNT, deleteManagedAccountSaga);
  yield takeEvery(actionTypes.USER_SEARCH, userSearchSaga);
}

export function* watchLogs() {
  yield takeEvery(actionTypes.FETCH_LOG, fetchLogSaga);
  yield takeEvery(actionTypes.FETCH_MULTI_VIEW_COLUMNS, fetchMultiViewColumnSaga);
  yield takeEvery(actionTypes.FETCH_LOGS_DETAILS, fetchLogsDetailsSaga);
  yield takeEvery(actionTypes.FETCH_MEMBERS_FOR_LOGS, fetchMembersForLogsSaga);
  yield takeEvery(actionTypes.FETCH_TAGS_FOR_LOGS, fetchTagsForLogsSaga);
  yield takeEvery(actionTypes.CREATE_LOG, createLogSaga);
  yield takeEvery(actionTypes.LOG_INVITE_NEW_USERS, logInviteNewUsersSaga);
  yield takeEvery(actionTypes.LOG_ADD_REMOVE_MEMBERS, logAddRemoveMembersSaga);
  yield takeEvery(actionTypes.LOG_REMOVE_ARCHIVED_USERS, logRemoveArchivedUsersSaga);
  yield takeEvery(actionTypes.LOG_LEAVE, logLeaveSaga);
  yield takeEvery(actionTypes.LOG_UPDATE_USER_ACCESS, logUpdateUserAccessSaga);
  yield takeEvery(actionTypes.LOG_TRANSFER_HOST, logTransferHostSaga);
  yield takeEvery(actionTypes.LOG_UPDATE, logUpdateSaga);
  yield takeEvery(actionTypes.FETCH_DRAFTS, fetchDraftsSaga);
}

export function* watchPost() {
  yield takeEvery(actionTypes.ADD_POST, addPostSaga);
  yield takeEvery(actionTypes.UPLOAD_POST_IMAGE, uploadPostImageSaga);
  yield takeEvery(actionTypes.FETCH_POST, fetchPostSaga);
  yield takeEvery(actionTypes.DELETE_POST, deletePostSaga);
  yield takeEvery(actionTypes.EDIT_POST, editPostSaga);
  yield takeEvery(actionTypes.ADD_COMMENT_IMAGE_TO_POST, addCommentImageToPostSaga);
  yield takeEvery(actionTypes.SUBMIT_POST_COMMENT, submitPostCommentSaga);
  yield takeEvery(actionTypes.ENTRY_COMMENT_UPDATE, entryCommentUpdateSaga);
  yield takeEvery(actionTypes.INIT_POST_FORM_START, initPostFormSaga);
  yield takeEvery(actionTypes.DUPLICATE_POST, duplicatePostSaga);
}

export function* watchGroups() {
  yield takeEvery(actionTypes.FETCH_GROUP_POSTS_LIST, fetchGroupPostsListSaga);
}

export function* watchFav() {
  yield takeEvery(actionTypes.ADD_IMPORTANT_PLACE, addImportantPlaceSaga);
  yield takeEvery(actionTypes.UPDATE_IMPORTANT_PLACE, updateImportantPlaceSaga);
  yield takeEvery(actionTypes.FETCH_IMPORTANT_PLACES, fetchImportantPlacesSaga);
}

export function* watchRecent() {
  yield takeEvery(actionTypes.FETCH_RECENT_PLACES, fetchRecentPlacesSaga);
  yield takeEvery(actionTypes.FETCH_USER_RECENT_ACTIVITY, fetchUserRecentActivitySaga);
}

export function* watchHelp() {
  yield takeEvery(actionTypes.FETCH_HELP_CONTENT, fetchHelpContentSaga);
}
